module.exports = __webpack_public_path__ + "../static/img/base_router.445b8915.png";